"use client";
import * as dc from "@/components/layout/list/defaultType";
import { Skeleton } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { DataInputParams } from "./inputType";
import { GetDataInputElement, getLinkValue, getValueLabel, getValueList } from "./inputFunction";
import { Input, QRCode, Space } from "antd";
import { checkDebug, Debug } from "@/util/debug";
import { useEffect, useState } from "react";
import { checkEmpty, checkEmptyValue } from "@/util/stringutil";
import { cn } from "@/lib/utils";
import LinkDisplay from "./link";
import { CommonButton } from "./inputButton";
import { Capacitor } from "@capacitor/core";
import { shareBase64 } from "@/util/apputil";
import { TransitionType } from "../layoutType";
const defaultQRType = "canvas"; //"svg";
function doDownload(ta: TransitionType, url: string, fileName: string) {
  if (Capacitor.isNativePlatform()) {
    shareBase64(ta, url, fileName);
  } else {
    const a = document.createElement("a");
    a.download = fileName;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

const downloadQRCode = (ta: TransitionType, id: string, type: string) => {
  if (type === "canvas") {
    const canvas = document.getElementById(id)?.querySelector<HTMLCanvasElement>("canvas");
    if (canvas) {
      const url = canvas.toDataURL();
      doDownload(ta, url, "QRCode.png");
    }
  } else {
    const svg = document.getElementById(id)?.querySelector<SVGElement>("svg");
    if (svg) {
      const svgData = new XMLSerializer().serializeToString(svg!);
      const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(blob);

      doDownload(ta, url, "QRCode.svg");
    }
  }
};

// const getQrValue = (
//   site: string | undefined,
//   pathname: string | undefined,
//   values: any | undefined,
//   value: any | undefined,
//   ids: string | string[] | undefined,
//   join: string | undefined,
// ): string => {
//   Debug(site, values, value, ids, join);

//   const site_fix = (site ?? (checkDebug() ? window.location.origin.toString() : window.location.origin.toString())) + (pathname ?? "/");
//   if (site_fix && value) {
//     const join_str = join ?? "_";
//     const ids_arr = typeof ids === "string" ? [ids] : ids;
//     const ids_value_str =
//       values && ids_arr
//         ? ids_arr
//             .map((id) => {
//               return encodeURIComponent(values[id]);
//             })
//             .join(join_str)
//         : undefined;
//     const url = site_fix + (!checkEmpty(ids_value_str) ? ids_value_str + "_" : "") + encodeURIComponent(value);
//     Debug("QRValue", url);
//     return url;
//   } else {
//     return "";
//   }
// };
export default function QRInput(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const ta = useTranslations("alert");
  const [pathName, setPathName] = useState(params.linkOption?.pathname);
  const [value, setValue] = useState(
    getLinkValue(
      params.linkOption?.useHost,
      params.linkOption?.useEncode,
      params.linkOption?.site,
      pathName,
      params.values,
      params.fixedValue ?? params.value,
      params.linkOption?.prevIds,
      params.valueJoin,
    ),
  );

  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setQRPathName"] = setPathName;
      temp_function["setQRValue"] = setValue;
    }
  }

  useEffect(() => {
    setValue(
      getLinkValue(
        params.linkOption?.useHost,
        params.linkOption?.useEncode,
        params.linkOption?.site,
        pathName,
        params.values,
        params.fixedValue ?? params.value,
        params.linkOption?.prevIds,
        params.valueJoin,
      ),
    );
  }, [
    params.linkOption?.useHost,
    params.linkOption?.useEncode,
    params.linkOption?.site,
    pathName,
    params.values,
    params.fixedValue,
    params.value,
    params.linkOption?.prevIds,
    params.valueJoin,
  ]);

  // Debug("QRInput", value);
  if (checkEmpty(value)) {
    return <Skeleton loading={params.loading ?? false}>{params.loading ?? false ? "blank" : " "}</Skeleton>;
  } else {
    //Debug(params);
    const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
    const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
    const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
    const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
    const { uselink, ...qrProp } = params.qrProp ? params.qrProp : { uselink: false };

    return (
      <Skeleton loading={params.loading ?? false}>
        {prev}
        {unitPrev}
        <Space id={params.name + "_space"} direction={"vertical"}>
          <QRCode
            {...qrProp}
            className={cn(params.inputClassName)}
            value={value}
            type={qrProp?.type ?? defaultQRType}
          />
          {qrProp.download !== undefined ? (
            <CommonButton
              {...qrProp.download}
              title={qrProp.download.title ?? "download"}
              buttonName={qrProp.download.buttonName ?? "DownloadSimple"}
              buttonFront={null}
              buttonClick={() => {
                downloadQRCode(ta, params.name + "_space", qrProp.type ?? defaultQRType);
              }}
            />
          ) : (
            ""
          )}
          {uselink === true ? <LinkDisplay {...params} /> : ""}
        </Space>
        {unit}
        {next}
      </Skeleton>
    );
  }
}
